var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#4A3628"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5736 3.27532C6.75313 2.90046 7.26183 2.91608 7.4264 3.27532L8.41386 5.35264L10.5982 5.68064C10.9872 5.74312 11.1369 6.24293 10.8526 6.53969L9.28163 8.14844L9.65567 10.4132C9.71552 10.8193 9.29659 11.1317 8.95248 10.9442L7.00748 9.86653L5.04752 10.9442C4.70341 11.1317 4.28448 10.8193 4.34433 10.4132L4.71837 8.14844L3.14741 6.53969C2.86314 6.24293 3.01275 5.74312 3.40175 5.68064L5.6011 5.35264L6.5736 3.27532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequested);
export default __webpack_public_path__ + "static/media/requested.44bec21ab0255bd13664002298460f86.svg";
export { ForwardRef as ReactComponent };